import { HFlow, Modal, ModalBody, ModalFooter, ModalFooterButton, ModalHeader, Text } from 'bold-ui'

interface MChatConfirmAvaliacaoModalProps {
  onConfirm: () => void
  onCancel: () => void
}

export function MChatConfirmAvaliacaoModal(props: Readonly<MChatConfirmAvaliacaoModalProps>) {
  const { onConfirm, onCancel } = props

  return (
    <Modal open size='small' closeOnBackdropClick={false} onClose={onCancel}>
      <ModalHeader
        title='Ao avaliar o M-CHAT-R, a entrevista de seguimento pode precisar de atualização'
        icon={{
          name: 'exclamationTriangleOutline',
          fill: 'alert',
        }}
      />
      <ModalBody>
        <Text>
          Se houver alterações nas perguntas que a criança falhou, será necessário reaplicar a entrevista de seguimento
          para manter os resultados consistentes.
        </Text>
      </ModalBody>
      <ModalFooter>
        <HFlow alignItems='center' justifyContent='flex-end'>
          <ModalFooterButton onClick={onCancel}>Cancelar</ModalFooterButton>
          <ModalFooterButton kind='primary' onClick={onConfirm}>
            Avaliar M-CHAT-R
          </ModalFooterButton>
        </HFlow>
      </ModalFooter>
    </Modal>
  )
}
